import createApi from "../utils/axiosInstance";

// Fetch particular user
export const fetchUser = async (userId, date) => {
  try {
    const api = createApi(false); // Token required
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await api.get(
      "/user/getUserById/" + userId + `?date=${date}&timezone=${tz}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Fetching user data failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const addNotification = async (date) => {
  try {
    const api = createApi(true); // Token required
    const response = await api.get(
      `/user/add-user-notifications/?date=${date}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "adding notification field failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};
export const markReadNotificationHandler = async (date) => {
  try {
    const api = createApi(true); // Token required
    const response = await api.get(`/user/mark-read-user-notifications`);
    return response.data;
  } catch (error) {
    console.error(
      "marking read notification field failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};
export const getPendingNotification = async (date) => {
  try {
    const api = createApi(true); // Token required
    const response = await api.get(`/user/get-pending-notifications`);
    return response.data;
  } catch (error) {
    console.error(
      "getting pending notification field failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const unsubscribeUserData = async (userId) => {
  try {
    const api = createApi(false); // Token required
    const response = await api.get(`/user/unsubscribe?userId=${userId}`);
    return response.data;
  } catch (error) {
    console.error(
      "unsubscribeUser field failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};
export const fetchRedirectCodeURL = async (code) => {
  try {
    const api = createApi(false); // Token required
    const response = await api.get("/user/get-short-url" + `?code=${code}`);
    return response.data;
  } catch (error) {
    console.error(
      "Fetching url data failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const fetchCurrentUserProfile = async (userId, date, diaryLevel) => {
  try {
    const api = createApi(false); // Token required
    const response = await api.get(
      "/user/get-user-generic-info/" +
        userId +
        `?date=${date}` +
        (diaryLevel ? `&diaryLevel=${diaryLevel}` : "")
    );
    return response.data;
  } catch (error) {
    console.error(
      "Fetching user profile data failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const fetchUserPoints = async ({
  month = "",
  year = "",
  challengeId = "",
  date
}) => {
  try {
    const api = createApi(true); // Token required
    const response = await api.get(
      `user/total-points?date=${date}&month=${month}&year=${year}&challengeId=${challengeId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Fetching user points failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

// Complete user profile
export const completeUserProfile = async (userData, userId, date) => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const api = createApi(false);
    const response = await api.post(
      `/user/editProfile/${userId}?date=${date}&tz=${tz}`,
      userData
    );
    if (response.data.user) {
      const { user, token } = response.data;
      // const hours = expiresIn?.split("h")[0];
      // const expirationTime = new Date().getTime() + hours * 60 * 60 * 1000;
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      // localStorage.setItem("expirationTime", expirationTime);
    }
    return response.data;
  } catch (error) {
    console.error(
      "Completing profile failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};

// Update user password
export const updatePassword = async (data) => {
  try {
    const api = createApi(true);
    const response = await api.post(`/user/change-password`, data);
    return response.data;
  } catch (error) {
    console.error(
      "Changing profile password failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};

export const generatePreSignedUrl = async (data) => {
  try {
    const api = createApi(false);
    const response = await api.post(`/user/generate-signed-url`, data);
    return response.data;
  } catch (error) {
    console.error(
      "Generating signed url data:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};

export const customerSupport = async (data) => {
  try {
    const api = createApi(true, true);
    const response = await api.post(`/user/customer-support`, data);
    return response.data;
  } catch (error) {
    console.error(
      "Customer support sending data failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};

export const submitQuestionQA = async (data) => {
  try {
    const api = createApi(true);
    const response = await api.post(`/admin/user/add-new-request`, data);
    return response.data;
  } catch (error) {
    console.error(
      "submitQuestionQA failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};

export const deleteS3File = async (data) => {
  try {
    const api = createApi(true);
    const response = await api.post(`/user/delete-s3-file`, data);
    return response.data;
  } catch (error) {
    console.error(
      "Deleting data:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};

export const deleteUser = async (userId, hardDeleteNeeded = false) => {
  try {
    const api = createApi(true);
    const response = await api.delete(
      `/admin/user/delete-user/` +
        userId +
        `?hardDeleteNeeded=${hardDeleteNeeded}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Deleting profile  failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};

// Get user type
export const getUserType = async () => {
  try {
    const api = createApi(false);
    const response = await api.get("/user/getUserTypeList");
    return response.data;
  } catch (error) {
    console.error(
      "Fetching user type failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};

// Subscribe
export const addSubscription = async (mode, email, dontAddProgram = false) => {
  try {
    const api = createApi(true);
    const response = await api.post(
      `/payment/subscription/create-subscription?interval=${mode}&dontAddProgram=${dontAddProgram}`,
      { email }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Subscription failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};

// Subscribe
export const addCoupon = async (couponCode) => {
  try {
    const api = createApi(true);
    const response = await api.post(
      `/payment/coupon-subscription/create-coupon-subscription`,
      { couponCode }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Subscription failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};

export const cancelSubscription = async (subscriptionId) => {
  try {
    const api = createApi(true);
    const response = await api.post(
      `/payment/subscription/cancel-subscription`,
      { subscriptionId }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Subscription failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};

export const getUserSubscription = async (mode, email) => {
  try {
    const api = createApi(true);
    const response = await api.post(
      `/payment/subscription/get-customer-subscription`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Subscription failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error.message;
  }
};

export const referFriend = async (data) => {
  try {
    const api = createApi(true);
    const response = await api.post(`/payment/coupon/refer-a-friend`, data);
    return response.data;
  } catch (error) {
    console.error(
      "Refer friend failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const editChallengeHandler = async (data) => {
  try {
    const api = createApi(true);
    const response = await api.post(
      `/admin/challenges/edit-challenge/${data.id}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error(
      "Editing challenge failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};
